<template>
  <!-- Loader -->
  <div :class="classes" v-if="options.isLoading">
    <div class="lds-circle">
      <small>{{ options.text }}</small>
      <div :class="`loader-${options.class}`"></div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    box: false,
    side: false,
    dark: false,
    options: {
      type: Object,
      default: function () {
        return { isLoading: true, text: 'Loading', class: 'default', delay: 1000 }
      }
    }
  },
  data() {
    return {
      state: {},
      default: {}
    }
  },
  computed: {
    classes() {
      return {
        'relative-container': this.box,
        'left': this.side === 'left',
        'right': this.side === 'right',
        'dark': this.dark
      }
    }
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  watch: {
    options: {
      handler() {
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.relative-container {
  position: relative;
  display: inline-block;
  width: 100px;

  .lds-circle {
    right: 0;
  }
  .lds-circle > div {
    margin-top: 0;
  }
  &.left .lds-circle {
    right: auto;
  }
  &.dark .lds-circle > small {
    color: #222;
  }
}

// Loading indicator
.lds-circle {
  z-index: 1;
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translate(0%, -50%);

  > div {
    $size: 15px;
    display: inline-block;
    width: $size;
    height: $size;
    padding: 5px;
    margin-top: 8px;
    border-radius: 50%;
    opacity: 0.65;
    background: #f28f1c;
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    &.loader-saving {
      background: #5cbb2a;
    }
  }
  > small {
    position: relative;
    top: -4px;
    font-size: 9px;
    opacity: 0.75;
    line-height: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}
@keyframes lds-circle {
  0%,
  100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}
</style>
